"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionContact = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
require("./SectionContact.scss");
var SectionContact = function SectionContact(_ref) {
  var className = _ref.className,
    contact = _ref.contact;
  var Icon = SectionContact.Icon;
  var rootClassName = (0, _classnames["default"])('cds-FooterSection-List', 'cds-FooterSection-List--Contact', className);
  if (!contact) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(Icon, {
    name: _Icon.ICON_NAME.location
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-FooterSection-ListItem--Contact"
  }, contact.address)), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(Icon, {
    name: _Icon.ICON_NAME.phone
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-FooterSection-ListItem--Contact"
  }, contact.phoneNumber)), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(Icon, {
    name: _Icon.ICON_NAME.mail
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-FooterSection-ListItem--Contact"
  }, contact.email)));
};
exports.SectionContact = SectionContact;
SectionContact.Icon = _Icon.Icon;